import React from 'react'; // 导入 useState Hook
import { useConfig } from 'context/ConfigContext.js';


const Features = () => {
  const config = useConfig();
  if (!config) return null; // Guard clause

  const { appName } = config;

  return (
      <section className="py-16 px-4 bg-white">
        <div id="appIndexFeature" className="container mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-sky-700">
            Powerful Features of {appName}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Feature Card 1 */}
            <div className="bg-gray-50 p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300">
              <div className="text-5xl text-sky-500 mb-4">📞</div>
              <h3 className="text-xl font-semibold mb-3">Free Global Calls</h3>
              <p className="text-gray-600">
                Make free calls to over 200 countries worldwide via WiFi or cellular data.
              </p>
            </div>
            {/* Feature Card 2 */}
            <div className="bg-gray-50 p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300">
              <div className="text-5xl text-green-500 mb-4">✨</div>
              <h3 className="text-xl font-semibold mb-3">HD Voice Quality</h3>
              <p className="text-gray-600">
                Enjoy crystal-clear call quality, as if you&apos;re talking face-to-face.
              </p>
            </div>
            {/* Feature Card 3 */}
            <div className="bg-gray-50 p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300">
              <div className="text-5xl text-purple-500 mb-4">📲</div>
              <h3 className="text-xl font-semibold mb-3">No App Required for Recipient</h3>
              <p className="text-gray-600">
                Directly call any landline or mobile number, the recipient doesn&apos;t need to have the {appName} app installed.
              </p>
            </div>
          </div>
        </div>
      </section>
  );
};

export default Features;